export default "__VITE_ASSET__BIR3nYjo__"